/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__options__modes__car_ev_limit = /** @type {(inputs: {}) => string} */ () => {
	return `Fahrzeug laden, wenn Sie … erreichen.`
};

const en_itinerary__options__modes__car_ev_limit = /** @type {(inputs: {}) => string} */ () => {
	return `Recharge when you reach...`
};

const es_itinerary__options__modes__car_ev_limit = /** @type {(inputs: {}) => string} */ () => {
	return `Recarga cuando llegues a…`
};

const fr_itinerary__options__modes__car_ev_limit = /** @type {(inputs: {}) => string} */ () => {
	return `Recharger lorsque vous atteignez...`
};

const it_itinerary__options__modes__car_ev_limit = /** @type {(inputs: {}) => string} */ () => {
	return `Ricarica quando raggiungi...`
};

const nl_itinerary__options__modes__car_ev_limit = /** @type {(inputs: {}) => string} */ () => {
	return `Laden wanneer u...bereikt`
};

const pt_itinerary__options__modes__car_ev_limit = /** @type {(inputs: {}) => string} */ () => {
	return `Recarregar quando atingir...`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car_ev_limit = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__options__modes__car_ev_limit(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__options__modes__car_ev_limit", locale)
	if (locale === "de") return de_itinerary__options__modes__car_ev_limit(inputs)
	if (locale === "en") return en_itinerary__options__modes__car_ev_limit(inputs)
	if (locale === "es") return es_itinerary__options__modes__car_ev_limit(inputs)
	if (locale === "fr") return fr_itinerary__options__modes__car_ev_limit(inputs)
	if (locale === "it") return it_itinerary__options__modes__car_ev_limit(inputs)
	if (locale === "nl") return nl_itinerary__options__modes__car_ev_limit(inputs)
	return pt_itinerary__options__modes__car_ev_limit(inputs)
};